import { collection, doc, getDoc, getDocs } from "firebase/firestore"

import { db } from "../../../firebase"
import { LoadingService } from "react-ui-components/components/LoadingService"

type PathInput = string | string[]

const splitPath = (path: PathInput): string[] =>
  Array.isArray(path) ? path : (String(path || ""))
    .split("/")
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0)

const getCollectionRef = (path: PathInput) => {
  const segments = splitPath(path)
  return collection(db, segments.join("/"))
}

const getDocumentRef = (path: PathInput) => {
  const segments = splitPath(path)
  return doc(db, segments.join("/"))
}

const get = async ({ key, setData, map, path, isCollection, setLoading, filterFunction }: any) => {
  try {
    if (setLoading) {
      setLoading(true)
    } else {
      LoadingService.setLoading(true)
    }

    if (isCollection) {
      const querySnapshot = await getDocs(getCollectionRef(path))

      const arr: any[] = []
      querySnapshot.forEach((docSnapshot) => {
        const data = docSnapshot.data()
        let addRecord = true
        if (filterFunction && filterFunction(data)) {
          addRecord = false
        }
        if (addRecord) {
          arr.push({ ...data, id: docSnapshot.id })
        }
      })
      setData && setData(arr)
      return arr
    }

    if (key) {
      const collectionRef = getCollectionRef(path)
      const documentRef = doc(db, collectionRef.path, key)
      const docSnap = await getDoc(documentRef)

      if (docSnap.exists()) {
        const rawData = { ...docSnap.data(), id: docSnap.id }
        const data = map ? map({ item: rawData, path: docSnap.ref.path }) : rawData
        setData && setData(data)
        return data
      }

      const fallbackSnapshot = await getDocs(collectionRef)
      const candidate = fallbackSnapshot.docs.find(
        (snapshot) =>
          snapshot.id === key ||
          String(snapshot.data()?.name || "").toLowerCase() === String(key || "").toLowerCase(),
      )
      if (candidate) {
        const rawData = { ...candidate.data(), id: candidate.id }
        const data = map ? map({ item: rawData, path: candidate.ref.path }) : rawData
        setData && setData(data)
        return data
      }

      setData && setData(null)
      return null
    }

    const docRef = getDocumentRef(path)
    const docSnap = await getDoc(docRef)
    if (docSnap.exists()) {
      const rawData = { ...docSnap.data(), id: docSnap.id }
      const data = map ? map({ item: rawData, path: docSnap.ref.path }) : rawData
      setData && setData(data)
    } else {
      setData && setData(null)
    }
    return null
  } catch (error) {
    console.error(`Exception trying to retrieve the ${key}`, error)
  } finally {
    if (setLoading) {
      setLoading(false)
    } else {
      LoadingService.setLoading(false)
    }
  }
}

export default get
